import React, { ReactNode } from 'react';
import { cn } from '../utils/cn';

const Circlebtn = ({ icon, className, onClick }: { icon: ReactNode, className?: string, onClick?: () => void }) => {
  return (
    <div onClick={() => onClick && onClick()} className={cn("rounded-full flex items-center justify-center cursor-pointer", className)}>
      {icon}
    </div>
  );
};

export default Circlebtn;